import React, { useEffect } from "react";
import { Typography } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actionGetClientTheme } from "../../../actions/AppSettings.action";
import { getClientDomain } from "../../../libs/domain.utils";

import "./PasswordResetSuccessView.css";
import { ArrowPrimaryButton } from "../../../components/Buttons/PrimaryButton";

function PasswordResetSuccessView() {
  const history = useHistory();
  const dispatch = useDispatch();
  const appSettings = useSelector((state) => state.app_setting);
  const clientTheme = appSettings?.client_theme;

  useEffect(() => {
    const domain = getClientDomain();
    if (domain && !clientTheme) {
      dispatch(actionGetClientTheme(domain));
    }
  }, [dispatch, clientTheme]);

  useEffect(() => {
    if (clientTheme?.fav_icon) {
      const link = document.querySelector("link[rel='shortcut icon']");
      if (link) {
        link.href = clientTheme.fav_icon;
      }
    }
  }, [clientTheme]);

  return (
    <div
      className="passwordResetSuccessPage"
      style={clientTheme?.background_image ? { backgroundImage: `url(${clientTheme.background_image})` } : {}}
    >
      <div
        className="passwordResetSuccessOverlay"
        style={clientTheme?.background_image ? { backgroundImage: `url(${clientTheme.background_image})` } : {}}
      ></div>

      <div className="passwordResetSuccessContainer">
        <div className="passwordResetSuccessCard">

          {/* Logo */}
          <div className="passwordResetSuccessLogoWrapper">
            <img
              src={
                clientTheme?.display_logo ||
                require("../../../assets/CRMAssets/psconnect_login_logo@2x.png")
              }
              alt="PS Connect"
              className="passwordResetSuccessLogo"
              style={{
                maxHeight: "80px",
                maxWidth: "220px",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Success Icon */}
          <div className="passwordResetSuccessIcon">
            <CheckCircleOutline
              style={{
                color: "#16C05B",
                fontSize: 54,
              }}
            />
          </div>

          {/* Heading */}
          <Typography className="passwordResetSuccessTitle">
            Password Reset!
          </Typography>

          {/* Description */}
          <Typography className="passwordResetSuccessDescription">
            Your password has been successfully updated.
            <br />
            You can now log in with your new password.
          </Typography>

          {/* Button */}
          <div className="passwordResetSuccessButtonWrapper">
  <ArrowPrimaryButton
    fullWidth
    onClick={() => history.push("/login")}
  >
    BACK TO LOGIN
  </ArrowPrimaryButton>
</div>

        </div>
      </div>
    </div>
  );
}

export default PasswordResetSuccessView;